import { Link } from "react-router-dom";
import { Sparkles, ChevronLeft } from "lucide-react";

export default function TermsPage() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-10 text-slate-300 leading-relaxed" data-testid="terms-page">
      <Link to="/" className="inline-flex items-center gap-1.5 text-xs text-slate-500 hover:text-amber-400 mb-6">
        <ChevronLeft className="h-3.5 w-3.5" /> Back
      </Link>

      <div className="flex items-center gap-2 mb-2">
        <Sparkles className="h-5 w-5 text-amber-400" />
        <h1 className="font-cinzel text-2xl sm:text-3xl font-bold text-amber-400 tracking-wider">Terms of Service</h1>
      </div>
      <p className="text-xs text-slate-500 mb-8">Last updated: February 2026</p>

      <section className="space-y-5 text-sm">
        <p>
          By using Tara Kundli you agree to these terms. If you do not agree, please do not use the service.
        </p>

        <h2 className="text-base font-semibold text-amber-400 mt-6">1. Service</h2>
        <p>
          Tara Kundli provides Vedic astrology birth-chart generation, personalised readings,
          Tarot readings, and marriage-compatibility analysis for <b>entertainment and self-reflection
          purposes</b>. We do not offer medical, financial, legal, or psychiatric advice.
        </p>

        <h2 className="text-base font-semibold text-amber-400 mt-6">2. Accounts</h2>
        <p>
          You are responsible for keeping your password confidential. You must be at least 13 years old to
          use the service. One account per person.
        </p>

        <h2 className="text-base font-semibold text-amber-400 mt-6">3. Purchases & subscriptions</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li>One-time credit packs and the Unlimited subscription are processed via Stripe on web and Android.</li>
          <li>Subscriptions auto-renew until cancelled. You can cancel any time from your account page.</li>
          <li>Refunds are handled on a case-by-case basis — email <a className="text-amber-400" href="mailto:support@tarakundli.com">support@tarakundli.com</a> within 7 days of purchase.</li>
          <li>The 1-hour live consultation with Mamta Dang is delivered via WhatsApp/Zoom and is non-refundable once scheduled.</li>
        </ul>

        <h2 className="text-base font-semibold text-amber-400 mt-6">4. Acceptable use</h2>
        <p>You agree not to:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Reverse-engineer, scrape, or resell the service or its outputs.</li>
          <li>Use the service to make decisions that require professional advice (medical, legal, financial).</li>
          <li>Abuse the service or use it to generate harmful content.</li>
        </ul>

        <h2 className="text-base font-semibold text-amber-400 mt-6">5. Nature of readings</h2>
        <p>
          Readings are generated automatically from your chart data. They may
          contain errors or omissions. Treat them as guidance, not certainty.
        </p>

        <h2 className="text-base font-semibold text-amber-400 mt-6">6. Disclaimer</h2>
        <p>
          The service is provided "as is" without warranty of any kind. To the maximum extent
          permitted by law, Tara Kundli is not liable for any indirect, incidental, or consequential
          damages.
        </p>

        <h2 className="text-base font-semibold text-amber-400 mt-6">7. Termination</h2>
        <p>
          We may suspend or terminate accounts that violate these terms. You may delete your
          account at any time from your profile page.
        </p>

        <h2 className="text-base font-semibold text-amber-400 mt-6">8. Changes to terms</h2>
        <p>
          We may update these terms; we will post the new version on this page and update the
          "Last updated" date. Continued use after changes means you accept them.
        </p>

        <h2 className="text-base font-semibold text-amber-400 mt-6">9. Contact</h2>
        <p>
          For questions, email <a className="text-amber-400" href="mailto:support@tarakundli.com">support@tarakundli.com</a>.
        </p>
      </section>
    </div>
  );
}
